import React from 'react';
import { Wifi, WifiOff, RefreshCw } from 'lucide-react';

const SyncStatus = ({ syncing, isOnline, lastSync }) => {
  if (!isOnline) {
    return (
      <div className="flex items-center justify-center gap-2 text-sm font-mono">
        <WifiOff className="w-4 h-4 text-red-400" />
        <span className="text-red-400">Offline</span>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center gap-2 text-xs sm:text-sm font-mono">
      {syncing ? (
        <RefreshCw className="w-4 h-4 text-yellow-400 animate-spin" />
      ) : (
        <Wifi className="w-4 h-4 text-emerald-400" />
      )}
      <span className="text-gray-400">{syncing ? 'Syncing...' : 'Live Sync'}</span>
      <span className="text-gray-600">•</span>
      <span className="text-gray-400 hidden sm:inline">Real-time updates</span>
      <span className="text-gray-400 sm:hidden">Live</span>
    </div>
  );
};

export default SyncStatus;
